import { FC, useCallback, useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';

import {
  withdrawVotePoll,
  withdrawAllVotesInGroupPoll,
  newWithdrawAllVotesInGroupPoll,
} from '@sdk/managers/VotesManager';

import { fetchPollDetails, FormattedPollDetail } from '@utils/Poll';
import { useAuth } from '@hooks/Auth';

import HeaderImage from '@components/elements/HeaderImage';
import Checkbox from '@components/elements/Checkbox';
import ButtonMighty from '@components/elements/ButtonMighty';

import './PollWithdrawPage.css';
import toast from 'react-hot-toast';
import useSwr, { mutate } from 'swr';
import { useGlobalContext } from '@context/customContext';

const WITHDRAW_REASONS = [
  "I've changed my mind",
  'Lost interest with the event',
  'False Event/Campaign',
  'Others',
];

const PollWithdrawPage: FC = () => {
  const {
    params: { pollId },
  } = useRouteMatch<{
    pollId: string;
  }>();
  const history = useHistory<any>();

  const { user, loading: authLoading, dbUser } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const { guest } = useGlobalContext();

  const { data } = useSwr<FormattedPollDetail>(
    pollId && authLoading === false
      ? ['/poll/detail', pollId, user === null]
      : null,
    fetchPollDetails
  );
  console.log(data)

  const [value, setValue] = useState<string>();

  const onSubmit = useCallback(async () => {
    if (dbUser?.id && guest) return;
    if (!value)
      return toast.error('Select a reason for withdrawing your vote.');
    setLoading(true);
    console.log(data?.poll);

    try {
      await newWithdrawAllVotesInGroupPoll(dbUser?.id || guest, pollId, value);
      // if (data?.poll.isGroup) {
      //   console.log('withdrawAllVotesInGroupPoll');
      //   await withdrawAllVotesInGroupPoll(dbUser.id, pollId, value);
      // } else {
      //   console.log('withdrawVotePoll');
      //   await withdrawVotePoll(['id'], pollId, null, dbUser.id, value);
      // }

      // Revalidate data
      await new Promise((resolve) => {
        setTimeout(async () => {
          await mutate(['/poll/voted', pollId, dbUser?.id || guest]);
          // Optimistic update
          await mutate(
            ['/poll/detail', pollId, user === null],
            (cache) => {
              if (!cache || cache.poll?.voteCount === undefined) return cache;

              return {
                poll: {
                  ...cache.poll,
                  voteCount:
                    cache.poll.voteCount > 0
                      ? cache.poll.voteCount - 1
                      : cache.poll.voteCount,
                },
                subPolls: cache.subPolls,
              };
            },
            false
          );
          resolve(true);
        }, 500);
      });

      toast.success('Withdrew your vote.');
      history.replace(`/poll/${pollId}?action=withdraw`);
    } catch (err: any) {
      console.error('withdrawVotePoll failed', err);
      toast.error(err.errors?.[0]?.message || err.message);
      history.replace(`/poll/${pollId}?action=withdraw`);
    }
  }, [dbUser, value, data, history, pollId, user, guest]);

  return (
    <div className="min-h-screen pb-32 bg-fixed bg-gray-darkest poll-x-pattern">
      <HeaderImage
        title={data?.poll.title || ''}
        titleSize={(data?.poll.title?.length || 0) > 15 ? 40 : 55}
        image={data?.poll.image?.url || 'image'}
        alt="profile picture"
      />
      <div className="container flex flex-col items-center mx-auto">
        <div className="p-4 w-108">
          <div className="p-4 text-white md:p-8 bg-gray-darkest">
            <h2 className="mb-6 text-2xl">Withdraw vote</h2>
            <div className="mb-6 space-y-4">
              {WITHDRAW_REASONS.map((reason, index) => {
                return (
                  <div
                    key={`withdraw-item-${index}`}
                    onClick={() => setValue(reason)}
                    role="button"
                    className="flex items-center"
                  >
                    <Checkbox checked={value === reason} readOnly />
                    <div className="ml-2 text-base">{reason}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="justify-center px-4 md:flex">
          <ButtonMighty
            onClick={onSubmit}
            disabled={loading}
            loading={loading}
            color="#ff001e"
            borderColor="#5600fb"
            textColor="#FFF"
            text="Withdraw vote"
            margin="0"
          />
        </div>
      </div>
    </div>
  );
};

export default PollWithdrawPage;
